import React from "react";
import { usePublisherAndContacts } from "@seabrookstudios/pitch2table";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import { usePublisherIdFromRoute } from "../games/WithGameIdFromRoute";
import { EmptyDetailCard } from "../core/EmptyDetailCard";
import { MySubmissionsWithPublisher } from "./MySubmissionsWithPublisher";
import { MyDocumentsWithPublisher } from "./MyDocumentsWithPublisher";
import { MySessionsWithPublisher } from "../sessions/MySessionsWithPublisher";
import { useDocumentTitle } from "usehooks-ts";
import { PublisherDetailCard } from "./PublisherDetailCard";

const MyPublisherDetail = () => {
  const publisherId = usePublisherIdFromRoute();
  const { data: publisherAndContacts = [], isLoading } = usePublisherAndContacts(publisherId);

  const [publisher] = publisherAndContacts;

  useDocumentTitle(`Pitch2Table${publisher ? ` - ${publisher.name}` : ""}`);

  if (isLoading) {
    return (
      <Card elevation={1} square={false}>
        <CircularProgress />
      </Card>
    );
  }

  if (!publisher) {
    return <EmptyDetailCard text="An error occurred loading publisher" />;
  }

  return (
    <>
      <PublisherDetailCard publisher={publisher} />
      <Box pt={1} />
      <MySubmissionsWithPublisher publisherId={publisherId} />
      <Box pt={1} />
      <MySessionsWithPublisher publisherId={publisherId} />
      <Box pt={1} />
      <MyDocumentsWithPublisher publisherId={publisherId} />
    </>
  );
};

export const MyPublisherDetailFromRoute = () => {
  const publisherId = usePublisherIdFromRoute();

  if (!publisherId) {
    return <EmptyDetailCard text="Select a publisher from the list on the left." />;
  }

  return <MyPublisherDetail />;
};
